export const COULEUR_EDITION_BAT = '#1c5ea6';
export const TYPE_EDITION_BAT = 'Bat';
export const TYPE_EDITION_BAT_MAIL = 'bat';
